/** Liczba PLN z wartości HotPay / HOTPAY_KWOTA (np. "10", "30,50"). */
export function parseKwotaNumber(kwota: string): number | null {
  const n = Number(kwota.trim().replace(',', '.'))
  return Number.isFinite(n) && n >= 0 ? n : null
}

/** Etykieta do UI, np. "10 zł" lub "17,10 zł". */
export function formatKwotaPln(kwota: string): string {
  const n = parseKwotaNumber(kwota)
  if (n === 0) return 'Za darmo'
  if (n === null) {
    const raw = kwota.trim()
    return raw ? `${raw} zł` : '—'
  }
  const display = Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',')
  return `${display} zł`
}
